export class AuthSettings {
  public clientId!: string;
  public loginFlow!: string;
  public signUpFlow!: string;
  public passwordResetFlow!: string;
  public scopes!: string;

  constructor() {
    this.clientId = "";
    this.loginFlow = "";
    this.signUpFlow = "";
    this.passwordResetFlow = "";
    this.scopes = "";
  }
}
